/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rules_Seo_Core_DescriptionInputs */



/**
* | output |
* | --- |
* | "Read the official Riftbound core game rules with version history and keyword reference." |
*
* @param {Rules_Seo_Core_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const rules_seo_core_description = /** @type {((inputs?: Rules_Seo_Core_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rules_Seo_Core_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Lies die offiziellen Riftbound-Grundregeln mit Versionsverlauf und Schlüsselwort-Verweisen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Consultez les règles de base officielles de Riftbound, avec l'historique des versions et les renvois vers les mots-clés.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("阅读 Riftbound 官方核心规则，附版本历史和关键词参考。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("閱讀 Riftbound 官方核心規則，附版本歷史與關鍵字參考。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("버전 기록과 키워드 참조가 포함된 Riftbound 공식 핵심 규칙을 확인하세요.")
	return /** @type {LocalizedString} */ ("Read the official Riftbound core game rules with version history and keyword reference.")
});